export class ListSelectedSetItemSelectedAction {
  constructor(public id: any, public selected: boolean) {}
}
